/**
 * 给指定元素添加class
 * @param ele
 * @param classname
 */
export const addClass = (ele, classname) => {
  if (!ele || !classname || ele.nodeType !== 1) {
    return;
  }
  let classArr = classname.split(' ');
  if (ele.classList) {
    for (var i = 0, len = classArr.length; i < len; i++) {
      let item = classArr[i];
      if (!ele.classList.contains(item)) {
        ele.classList.add(item);
      }
    }
    return ele;
  } else {
    let classNameArr = ele.className && ele.className.length > 0 ? ele.className.split(' ') : [];
    if (classNameArr.length === 0) {
      ele.className = classname;
      return;
    }
    // 合并两个数组
    Array.prototype.push.apply(classNameArr, classArr);
    classNameArr = tool.arrayNoReapeat(classNameArr);
    ele.className = classNameArr.join(' ');
    return ele;
  }
};
/**
 * 给指定元素移除class
 * @param ele
 * @param classname
 */
export const removeClass = (ele, classname) => {
  if (!ele || !classname || ele.nodeType !== 1) {
    return;
  }
  let classArr = classname.split(' ');
  if (ele.classList) {
    for (var i = 0, len = classArr.length; i < len; i++) {
      let item = classArr[i];
      if (ele.classList.contains(item)) {
        ele.classList.remove(item);
      }
    }
    return ele;
  } else {
    let classNameArr = ele.className && ele.className.length > 0 ? ele.className.split(' ') : [];
    if (classNameArr.length === 0) {
      return;
    }
    for (var i = classNameArr.length; i >= 0; i--) {
      for (var j = 0, len2 = classArr.length; j < len2; j++) {
        if (classNameArr[i] === classArr[j]) {
          classNameArr.splice(i, 1);
        }
      }
    }
    ele.className = classNameArr.join(' ');
    return ele;
  }
};
// 元素绑定事件
export const on = (element, event, handler) => {
  if (element && event && handler) {
    if (document.addEventListener) {
      element.addEventListener(event, handler, false);
    } else if (element.attachEvent) {
      element.attachEvent('on' + event, handler);
    }
  }
};
// 元素解绑事件
export const off = (element, event, handler) => {
  if (element && event && handler) {
    if (document.removeEventListener) {
      element.removeEventListener(event, handler, false);
    } else if (element.attachEvent) {
      element.detachEvent('on' + event, handler);
    }
  }
};
